import styled from '@emotion/styled'
import React from 'react'
import { getComponentTheme } from '../../../__styling'

type ReadMoreProps = {
    readTime: number | null
}

export const ReadMore = ({ readTime }: ReadMoreProps) => (
    <Link>{`Read more${
        readTime ? ` (${Math.ceil(readTime)} min)` : ''
    } ->`}</Link>
)

const Link = styled.div(({ theme }) => {
    const linkTheme = getComponentTheme(theme, 'card').link
    return {
        alignSelf: linkTheme.alignSelf,
        fontFamily: theme.fonts.serif,
        fontSize: 16,
        textDecoration: 'underline',
        color: linkTheme.textColor,
    }
})
